// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  DeleteExperienceFromFavoriteData,
  DeleteExperienceFromFavoriteResponses,
  GetCalendarEventsChipsData,
  GetCalendarEventsChipsResponses,
  GetCountryInfoBySlugData,
  GetCountryInfoBySlugResponses,
  GetExperienceAggregationsData,
  GetExperienceAggregationsResponses,
  GetExperiencesFavoritesListData,
  GetExperiencesFavoritesListResponses,
  GetExperiencesListData,
  GetExperiencesListResponses,
  GetLinksListData,
  GetLinksListResponses,
  GetRelatedArticlesByCityIdData,
  GetRelatedArticlesByCityIdResponses,
  GetReviewsListData,
  GetReviewsListResponses,
  GetSeoCategoryBySlugData,
  GetSeoCategoryBySlugResponses,
  GetSeoCategoryInfoByIdData,
  GetSeoCategoryInfoByIdResponses,
  GetTagsData,
  GetTagsResponses,
  GetToursActivitiesData,
  GetToursActivitiesResponses,
  PutExperienceToFavoriteData,
  PutExperienceToFavoriteResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * ссылки для перелинковки
 */
export const getLinksList = <ThrowOnError extends boolean = false>(options: Options<GetLinksListData, ThrowOnError>) =>
  (options.client ?? client).get<GetLinksListResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/category/cities-tours-days-by-city/{cityId}/',
    ...options,
  });

/**
 * список тегов
 */
export const getTags = <ThrowOnError extends boolean = false>(options: Options<GetTagsData, ThrowOnError>) =>
  (options.client ?? client).get<GetTagsResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/category/cities-tours-tags-by-slug/{categorySlug}/',
    ...options,
  });

/**
 * Получение информации для seo-категории по слагу
 */
export const getSeoCategoryBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetSeoCategoryBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSeoCategoryBySlugResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/category/{categorySlug}/',
    ...options,
  });

/**
 * Получение seo-информации
 */
export const getSeoCategoryInfoById = <ThrowOnError extends boolean = false>(
  options: Options<GetSeoCategoryInfoByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSeoCategoryInfoByIdResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/seo_category/',
    ...options,
  });

/**
 * Get related articles
 */
export const getRelatedArticlesByCityId = <ThrowOnError extends boolean = false>(
  options: Options<GetRelatedArticlesByCityIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetRelatedArticlesByCityIdResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/articles/',
    ...options,
  });

/**
 * Получить интервалы дат для чипсов календаря
 */
export const getCalendarEventsChips = <ThrowOnError extends boolean = false>(
  options?: Options<GetCalendarEventsChipsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCalendarEventsChipsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/calendar-filters/',
    ...options,
  });

/**
 * Получить информацию о стране по slug
 */
export const getCountryInfoBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetCountryInfoBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCountryInfoBySlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/countries/{countrySlug}/',
    ...options,
  });

/**
 * Получение списка экскурсий/туров в избранном
 */
export const getExperiencesFavoritesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperiencesFavoritesListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperiencesFavoritesListResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/favorites/',
    ...options,
  });

/**
 * Удалить экспериенс из избранного
 */
export const deleteExperienceFromFavorite = <ThrowOnError extends boolean = false>(
  options: Options<DeleteExperienceFromFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteExperienceFromFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
  });

/**
 * Добавить экспериенс в избранное
 */
export const putExperienceToFavorite = <ThrowOnError extends boolean = false>(
  options: Options<PutExperienceToFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutExperienceToFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Получение списка отзывов
 */
export const getReviewsList = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewsListData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetReviewsListResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/reviews/',
    ...options,
  });

/**
 * Получить список типов активности
 *
 * Получить список типов активности для туров
 */
export const getToursActivities = <ThrowOnError extends boolean = false>(
  options?: Options<GetToursActivitiesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetToursActivitiesResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/tour-activities/',
    ...options,
  });

/**
 * Получение списка экскурсий/туров
 */
export const getExperiencesList = <ThrowOnError extends boolean = false>(
  options: Options<GetExperiencesListData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetExperiencesListResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/',
    ...options,
  });

/**
 * Получить агрегации экспириенсов
 *
 * Получить агрегированные данные для экспириенсов
 */
export const getExperienceAggregations = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperienceAggregationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperienceAggregationsResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/aggregations/',
    ...options,
  });
